import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const spotlightVideoSchema = z.object({
  assetId: z.string(),
  assetVersion: z.string().optional(),
  headline: z.string(),
  description: z.string().optional(),
  videoUrl: z.string().optional(),
  productFeatures: z.array(z.string()).optional(),
  optimized: z.boolean().optional(),
  state: z.enum(["active", "paused", "archived"]).optional(),
  adGroupIds: z.array(z.string()).optional(),
});

const spVideoByAsinResponseSchema = z.object({
  asin: z.string(),
  ad_group: z.string().optional(),
  videos: z.array(spotlightVideoSchema),
  state: z.enum(["enabled", "paused"]).optional(),
  optimizeText: z.boolean().optional(),
  deliveryStatus: z.string().nullable().optional(),
  deliveryReasons: z.array(z.string()).optional(),
  moderationStatus: z.string().nullable().optional(),
  policyViolations: z.array(z.string()).optional(),
});

const videoInfoEntrySchema = z.object({
  asin: z.string(),
  ad_group: z.string().optional(),
  videos: z.array(spotlightVideoSchema),
});

const spVideoFullResponseSchema = z.object({
  video_info: z.array(videoInfoEntrySchema),
});

const updateSpSpotlightVideoSpecBodySchema = z.object({
  asin: z.string(),
  videos: z.array(spotlightVideoSchema).optional(),
  optimizeText: z.boolean().optional(),
  state: z.enum(["enabled", "paused"]).optional(),
});

export const spVideoApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getSpVideo",
    method: "get",
    path: "/ads/:id/sp-video/",
    parameters: [{ name: "asin", type: "Query", schema: z.string() }],
    status: 200,
    response: spVideoByAsinResponseSchema,
  })
    .addEndpoint({
      alias: "updateSpSpotlightVideoSpec",
      method: "put",
      path: "/ads/:id/sp-video/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: updateSpSpotlightVideoSpecBodySchema,
        },
      ],
      status: 200,
      response: spVideoFullResponseSchema,
      errors: [{ status: 400, schema: z.object({ message: z.string() }) }],
    })
    .build(),
);
